import React from 'react';

import PropTypes from 'prop-types';

import Button, { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import Footer from './Footer';
import { FooterProps } from '../types';

const DefaultFooter = ({ today, reset, renderFooterActions }: FooterProps) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <Footer>
      {renderFooterActions?.({ today })}
      {reset && (
        <LinkButton
          onClick={reset}
          size={Button.SIZES.SMALL}
          style={{ marginTop: theme.spacing.XXS }}
        >
          {T.translate('RESET')}
        </LinkButton>
      )}
    </Footer>
  );
};

DefaultFooter.displayName = 'DefaultFooter';

DefaultFooter.propTypes = {
  today: PropTypes.func.isRequired,
  renderFooterActions: PropTypes.func,
  reset: PropTypes.func,
};

export default DefaultFooter;
